<template>
  <v-select
    :items="highlights"
    item-value="key"
    item-text="name"
    label=""
    dense
    hide-details
    outlined
    :menu-props="{
      bottom: true,
      offsetY: true,
      transition: 'scale-transition',
    }"
    single-line
    class="py-2 px-0"
    @change="changed"
    v-model="selected"
  >
  </v-select>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  data() {
    return {
      selected: { key: "on", name: "Подсветка включена" },
      highlights: [
        { key: "on", name: "Подсветка включена" },
        { key: "off", name: "Подсветка выключена" },
        { key: "mean_less_more", name: "Меньше/Больше среднего" },
        { key: "min_less", name: "Меньше минимального" },
        { key: "min_more", name: "Больше минимального" },
        { key: "mean_less", name: "Меньше среднего" },
        { key: "mean_more", name: "Больше среднего" },
        { key: "max_less", name: "Меньше максимального" },
        { key: "max_more", name: "Больше максимального" },
      ],
    };
  },
  methods: {
    ...mapActions(["addHighlight"]),
    ...mapGetters(["getSettings"]),
    changed: function () {
      // console.log("Changed:" + this.selected);
      this.addHighlight({ type: "time", value: this.selected });
    },
  },
  created() {
    let settings = this.getSettings().highlights;
    if (settings.time == "") {
      return;
    }
    let value = settings.time;
    // console.log("VALUE: " + value);
    for (const item of this.highlights) {
      if (item.key == value) this.selected = value;
    }
  },
};
</script>

<style scoped></style>
